<template>
    <div :class="getCSSClass('user-editor-container')">
        <div :class="getCSSClass('repository-manager-function-popup-row')">
            <div :class="getCSSClass('repository-manager-function-popup-column')"><label style="width: 100%" v-html="userLabel"></label></div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <employee-picker v-if="defaultUser == -1"
                                 :urls="urls"
                                 v-on:input="emitValue"
                                 v-model="personId"
                ></employee-picker>
                <label v-if="defaultUser != -1" v-html="username"
                       :class="getCSSClass('user-editor-username-label')"></label>
            </div>

        </div>
        <div :class="getCSSClass('repository-manager-function-popup-row')">
            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Profilkép')"></label></div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <file-picker-native v-model="userprofilepicture"
                                    v-on:input="emitValue"
                                    :label="translate('Feltölt')"
                                    :upload-url="operationsUrl"></file-picker-native>
            </div>
        </div>
        <div :class="getCSSClass('repository-manager-function-popup-row')">
            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Jelszó')"></label></div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <input type="text" v-model="password" :placeholder="translate('Ha nem szeretné módosítani, hagyja üresen')">
            </div>
        </div>
        <div :class="getCSSClass('repository-manager-function-popup-row')" style="border: 0px !important">
            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Jogosultságok')"></label></div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <div v-if="privilegesLoading" v-html="loadingIndicator"></div>
                <div v-if="!privilegesLoading && currentJobpositionId" style="width: 100%; display: flex; flex-direction: column">
                    <label for="admin_checkbox" :class="getCSSClass('user-editor-admin-label')" style="width: 100% !important">
                        <input type="checkbox" v-model="admin" id="admin_checkbox" style="margin-right: .5rem; flex-grow: 0">
                        {{ translate('Adminisztrátor (teljes hozzáférés') }}
                    </label>
                    <privilege-picker v-show="!admin"
                                      v-on:input="emitValue"
                                      :jobposition-id="currentJobpositionId"
                                      :presets="privilegepickerprops.presets"
                                      :modules="privilegepickerprops.modules"
                                      :accesslevels="privilegepickerprops.accesslevels"
                                      v-model="privileges"></privilege-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            operationsUrl: {type: String},
            value: {},
            urls: {},
            privilegepickerprops: {type: Object},

        },
        data: function () {
            return {
                defaultUser: -1,
                userprofilepicture: '',
                privileges: {},
                personId: -1,
                privilegesLoading: false,
                currentJobpositionId: null,
                password: '',
                admin: false,
            }
        },
        created() {
            this.parseValue();
        },
        mounted() {
        },
        methods: {
            emitValue: function() {
                this.$emit('input', this.valueToEmit);
            },
            fetchJobposition: function() {
                this.privilegesLoading = true;
                window.axios.post(this.operationsUrl, {action: 'fetchJobposition', id: this.personId})
                    .then((response) => {
                        this.currentJobpositionId = parseInt(response.data);
                        this.privilegesLoading = false;
                        this.emitValue();
                    }).catch((error) => {
                        console.log(error);
                        alert(error.response.data);
                        this.privilegesLoading = false;
                });
            },
            privilegelist: function(privileges) {
                let result = {}
                Object.keys(privileges).forEach((s) => {
                    result[s] = privileges[s].accesslevel;
                });
                //console.log({m: 'privilegelist', r: result, o: privileges});
                return result;
            },
            parseValue: function() {
                if (this.value) {
                    this.defaultUser = {...this.value.id}
                    this.userprofilepicture = this.value.profilepicture;
                    this.personId = this.value.person_id;
                    this.privileges = {...this.privilegelist(this.value.privileges_keyed)},
                    this.admin = this.value.is_admin == 1;
                } else {
                    this.admin = false;
                    this.password = '';
                }

            },
        },
        computed: {
            valueToEmit: function() {
                let result = {
                    name: null,
                    person_id: this.personId,
                    privileges_keyed: {},
                    profilepicture: this.userprofilepicture,
                    is_admin: this.admin ? 1 : 0,
                }
                if (this.password.trim() != '') {
                    result['password'] = this.password;
                }
                if ((this.value) && (this.value.name)) {
                    result.name = this.value.name
                }
                if ((this.privilegepickerprops.presets[this.currentJobpositionId])) {
                    result.privileges_keyed = {...this.privilegepickerprops.presets[this.currentJobpositionId]};
                }
                if (this.privileges) {
                    result.privileges_keyed = {...this.privileges}
                }
                return result;
            },
            username: function() {
                if ((this.value) && (this.value.name)) {
                    return this.value.name;
                }
                return '';
            },
            userLabel: function() {
                return this.defaultUser == -1
                    ? this.translate('Felhasználó típusa')
                    : this.translate('Munkatárs');
            }
        },
        watch: {
            personId: function() {
                this.fetchJobposition();
            },
            password: function() {
                this.emitValue();
            },
            admin: function() {
                this.emitValue();
            },
            userprofilepicture: function() {
                this.emitValue();
            },
            privileges: function(newValue, oldValue) {
                this.emitValue();
            }
        }

    }
</script>
